import { CLIENT_CONTRACT } from "./client_contract"

// Web-only policy is generated into the same checked-in contract as mobile
// policy, then named here so browser consumers share one immutable seam.
export const WEB_TRACKER_POLICY = Object.freeze({ ...CLIENT_CONTRACT.web.tracker })
export const WEB_MAP_POLICY = Object.freeze({ ...CLIENT_CONTRACT.web.map })
